import { useBlockedFeature } from '../../../../hooks/useServerFeature';
import { useUserInfo } from '../../context/UserInfo';

export type AvatarPermissions = {
  canUpload: boolean;
  canDelete: boolean;
  // False when the modal would have nothing left to offer, so its entry point
  // can be hidden instead of opening a dead end.
  canOpenModal: boolean;
};

export const useAvatarPermissions = (): AvatarPermissions => {
  const { avatarUrl } = useUserInfo();
  const canUpload = !useBlockedFeature('Avatar_Upload');
  const canDelete = !useBlockedFeature('Avatar_Deletion');

  return {
    canUpload,
    canDelete,
    canOpenModal: canUpload || (canDelete && !!avatarUrl),
  };
};
